"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Nights = _interopRequireDefault(require("../Nights"));
var _Row = _interopRequireDefault(require("../Row"));
var _Cell = require("../Cell");
var _helpers = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var mapper = R.addIndex(R.map);
var PricesMatrix = function PricesMatrix(_ref) {
  var activeOfferID = _ref.activeOfferID,
    currency = _ref.currency,
    nightsRange = _ref.nightsRange,
    offers = _ref.offers,
    onPriceClick = _ref.onPriceClick;
  var groupedPrices = (0, _react.useMemo)(function () {
    return offers && (0, _helpers.groupPrices)(offers, nightsRange);
  }, [nightsRange, offers]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultMatrix,
    "data-nights-length": nightsRange.length
  }, /*#__PURE__*/_react.default.createElement(_Nights.default, {
    range: nightsRange
  }), R.map(function (_ref2) {
    var date = _ref2.date,
      group = _ref2.offers;
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      key: date
    }, /*#__PURE__*/_react.default.createElement(_Cell.Date, {
      value: date
    }), mapper(function (offer, index) {
      return offer ? /*#__PURE__*/_react.default.createElement(_Cell.Price, {
        active: activeOfferID === offer.id,
        currencySymbol: currency.symbol,
        food: offer.food,
        isMinPrice: offer.isMinPrice,
        key: offer.id,
        price: offer.price[currency.code],
        onClick: function onClick() {
          return onPriceClick(offer);
        }
      }) : /*#__PURE__*/_react.default.createElement(_Cell.Item, {
        key: index
      });
    }, group));
  }, groupedPrices));
};
PricesMatrix.propTypes = {
  currency: _propTypes.default.object.isRequired,
  nightsRange: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onPriceClick: _propTypes.default.func.isRequired,
  activeOfferID: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(PricesMatrix);